import React, {Fragment, useContext} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import {getFieldValue} from "./contractsFieldsFunctions";
import ContractsContext from "./contractsContext";
import {setContractsValues} from "../../../actions/contractsActions";

const ContractsPopupCheckboxField = (props) => {

  const {fieldIndex, fieldName, fieldCoords, setContractsValues, contractsValues} = props;

  const {activeContract, activeContractPage} = useContext(ContractsContext);

  const fieldValue = getFieldValue(activeContractPage, fieldIndex, activeContract, contractsValues);
  const style = {
    left: fieldCoords.left,
    top: fieldCoords.top + 2
  }

  const onCheckClick = () => {
    setContractsValues({
      contractId: activeContract.id,
      pageIndex: activeContractPage,
      fieldIndex,
      name: fieldName,
      value: !fieldValue,
    });
  }

  return (
    <div className={'contract-body__custom-field contract-body__custom-field-checkbox'}
         key={`checkbox_${fieldIndex}`}
         style={style}
         onClick={onCheckClick}>
      {fieldValue ? (
        <Fragment>
          <div className="contract-body__custom-field-checkbox-checked-1" />
          <div className="contract-body__custom-field-checkbox-checked-2" />
        </Fragment>
      ) : null}
    </div>
  )
};

ContractsPopupCheckboxField.propTypes = {
  fieldIndex: PropTypes.number.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldCoords: PropTypes.object.isRequired,
}

const mapStateToProps = (store) => {
  const {contractsValues} = store.contractSigningState;
  return {
    contractsValues,
  };
};

const mapDispathToProps = {
  setContractsValues,
}

export default connect(mapStateToProps, mapDispathToProps)(ContractsPopupCheckboxField)
